import { render, staticRenderFns } from "./HistoricContainer.vue?vue&type=template&id=79e507cb&scoped=true&"
import script from "./HistoricContainer.vue?vue&type=script&lang=js&"
export * from "./HistoricContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e507cb",
  null
  
)

export default component.exports